import { render } from "./NewsReader.vue?vue&type=template&id=612baa1a&scoped=true"
import script from "./NewsReader.vue?vue&type=script&lang=js"
export * from "./NewsReader.vue?vue&type=script&lang=js"

import "./NewsReader.vue?vue&type=style&index=0&id=612baa1a&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-612baa1a"]])

export default __exports__